import Vue from 'vue'
import { countryOptions } from "@/resource/selectOptions"
import { enquiryTopicOptions } from "@/resource/selectOptions"

export const formBus = new Vue({
  data: {
    fields: {
      //Step 1
      firstName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      lastName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      email: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        timer: null,
        loading: false
      },
      country: {
        value: "",
        options: countryOptions,
        validationIcon: "fas fa-check",
        valid: null,
        validationMessage: null
      },
      mobileNumber: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      //Step 2
      companyName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      // enquiryTopic: {
      //   value: "",
      //   validationIcon: "",
      //   valid: null,
      //   validationMessage: null,
      //   options: enquiryTopicOptions
      // },
      message: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      employeeCount: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      termsAccepted: false
    },
    error: false,
    errorMessage: "",
    notice: {
      open: false,
      message: "",
      title: "Notice",
      persistent: true,
    }
  }
});